const API = require('./api');
const Edition = require('core/src/edition').default;
const Function = require('core/src/function');
const _ = require('lodash');
const Err = require('utils/src/error');
const { writable } = require('core/src/utils/read-only');

Edition.setBuildFeature(Edition.Feature.FUNCTION_API, true);

API.prototype.execute = function(...args) {
	if (!Edition.hasFeature(Edition.Feature.FUNCTION_API)) {
		const error = Edition.functionNotAvailableError('API');
		this.error(error);
		throw error;
	}
	return Function.prototype.execute.call(this, ...args);
};

API.prototype.onExecute = function() {
	const input = this.readModel('input');
	const headers = _.cloneDeep(writable(this.readModel('_request.headers'))) || {};

	this.updateModel('_path.apiInstance', this._instanceID);

	this.responseTimeoutReset();

	this.executeTriggers({
		type: 'request',
		input: input,
		headers
	});
};

API.prototype.responseTimeoutReset = function() {
	if (this.timeoutHandle) {
		clearTimeout(this.timeoutHandle);
	}

	let timeoutMs = this.readModel('timeout');

	if (_.isFinite(timeoutMs) && timeoutMs > 0) {
		this.timeoutHandle = setTimeout(
			() => {
				this.fire(API.Event.Out.RESPONSE, {
					content: 'Server timeout', 
					status: 504, 
					headers: _.cloneDeep(writable(this.readModel('headers')))
				});
				this.fire(API.Event.Out.CLOSE_CONNECTION, {});
				_.defer(() => this.close());
			},
			timeoutMs
		)
	}
}

API.prototype.onUpdate = async function() {
	const error = this.readModel('error');
	if(!_.isNil(error)) {
		const err = new Err(error);
		this.fire(API.Event.Out.ERROR, err);
		this.error(err);
		return;
	}

	let response = this.readModel('response');
	let status = this.readModel('status');
	if(! _.isNil(response)) {
		this.responseTimeoutReset();

		// We don't want to bother listeners with ReadOnly Proxies
		await this.fire(API.Event.Out.RESPONSE, {
			headers: _.cloneDeep(writable(this.readModel('headers'))),
			content: _.cloneDeep(writable(response)),
			status: status
		});

		// Set back to null to be able to be updated
		this.updateModel('response', null);
	}

	if (_.includes(['true', true], this.readModel('end'))) {
		this.fire(API.Event.Out.CLOSE_CONNECTION, {});
		_.defer(() => this.close());
	}
};

API.prototype.onClose = function() {
	if (this.timeoutHandle) {
		clearTimeout(this.timeoutHandle);
	}
}
